<script setup lang="ts">
import CompactId from "./CompactId.vue"

withDefaults(
  defineProps<{
    maxClass?: string
    title?: string
    value: string
  }>(),
  {
    maxClass: "max-w-[8rem]",
    title: "Session id"
  }
)
</script>

<template>
  <CompactId prefix="ses" :max-class="maxClass" :title="title" :value="value" />
</template>
